import styled from 'styled-components';

export const StyledCard = styled.div`
  border: 4px solid transparent;
  border-radius: var(--border-radius-base);
  padding: var(--padding-base);
  min-height: 200px;
  background-color: var(--white);

  &.card {
    &_border {
      border-color: var(--gray);
    }

    &_shadow {
      box-shadow: 0 2px 36px 0 rgb(0 0 0 / 8%);
    }

    &_primary {
      border-color: var(--primary);
    }

    &_success {
      border-color: var(--success);
    }

    &_danger {
      border-color: var(--danger);
    }
  }
`;
